import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  gridPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { BranchTaxCreditableEditService } from './branch-tax-creditable-edit.service';

@Component({
    selector: 'gtw-branch-tax-creditable-edit',
    templateUrl: './branch-tax-creditable-edit.component.html',
    styleUrls: ['./branch-tax-creditable-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BranchTaxCreditableEditComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  baseURLs: any = { 'admin': '', 'api': '', 'custom': '', 'efile': '', 'pdfEngine': '', 'bulkPdfEngine': '' };

  filterParams: any = {};

  globalService: any;
  appService: any = {
    USER_SETTINGS: '',
    SERVER_CONFIG: ''
  };
  GENERAL_CONFIG: any;

  rowData: any = {};
  gridData: any = {};

  // STANDARD COMPONENT PROPERTIES
  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = true;
  modalTitle = "Branch Tax for LEID";

  // Entity data properties
  entityList: any[] = [];
  leId: string = '';
  cdr_no: string = '';
  leType: string = '';

  // Form data
  formData: any = {
    panel: true,
    enableCreditablePanel: true,
    enableNonCreditablePanel: false,
    spinner: true,
    isSection909SplitrTax: false,
    editFlagSet: false,
    creditableDropDown: [],
    generatedLeidDropDown: [],
    branchTaxTrailBalanceAmt: 0,
    variance: 0,
    openVariance: 0,
    totalBranchTaxes: 0,
    selectedBasketCatg: '',
    genLeid: '',
    selectedCountryDesc: '',
    selectedCountryKey: '',
    selectedBranchTaxLEID_Orgnl_CountryKey: '',
    creditTaxAmt: '',
    applicableYearKey: '',
    explainUsEntity: 'Not Applicable',
    creditableTagKey: null,
    selectStdReasonCd: '',
    detailReason: '',
    applicableYearKey2: '',
    nonCrdBrAmount: '',
    selectedSplitterBasketCatg: '',
    selectedSplitterCountryDesc: '',
    selectedSplitterCountryKey: '',
    nonCrdtableTagKey: null,
    selectedIssue: null,
    filterTaxYear: '',
    scenario: '',
    clientKey: 0,
    LEID: '',
    ReturnAsFiled: false,
    explainUsEntityRestore: '',
    selectedSavedCountryKey: ''
  };

  // Dropdown data
  codeCombinationData: any[] = [];
  issueDropdownData: any[] = [];
  basketCatgData: any[] = [];
  countryData: any[] = [];
  taxYearData: any[] = [];
  stdReasonCodeData: any[] = [];
  basketCodeDefault: any[] = [];
  countryUS: any[] = [];
  taxPriorYearStdReason: any[] = [];
  section909SplitrTax: any[] = [];
  filteredTaxYearData: any[] = [];
  filteredTaxYearForCreditable: any[] = [];
  attribMastData: any[] = [];
  defaultsMultipleSelected: any[] = [];
  creditableRecords: any[] = [];
  nonCreditableRecords: any[] = [];
  ftcTagDtlsData: any[] = [];
  summaryInfo: any[] = [];
  gridDataMultipleSelect: any = null;
  isAmendedScenario: boolean = false;
  taxPriorYearCodeKey: string = '';
  section909SplitrTaxKey: string = '';
  logged_in_user: string = '';
  is_locked: any = null;

  // Data loading optimization
  private dataLoadingStates = {
    entityData: false,
    formData: false
  };

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private branchTaxService: BranchTaxCreditableEditService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    if (this.rowData && Object.keys(this.rowData).length > 0) {
      this.setupEntityData();
      this.showFormLoader = false;
    } else {
      this.showFormLoader = true;
    }
    this.init();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.defaultsMultipleSelected = [];
    this.ftcTagDtlsData = [];
    this.creditableRecords = [];
    this.nonCreditableRecords = [];
    this.gridDataMultipleSelect = null;
    this.dataLoadingStates = { entityData: false, formData: false };
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.appService.USER_SETTINGS = header.userSettingsData || {};
    this.appService.SERVER_CONFIG = header.serverConfigData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    const row = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(row) ? (row[0] || {}) : row;
    this.gridData = gridPayloadFromActiveScreen(activeScreen) || {};
  }

  init() {
    try {
      if (this.rowData && Object.keys(this.rowData).length > 0 && this.GENERAL_CONFIG?.base_url) {
        this.setupEntityData();
        this.loadInitialData();
      }
    } catch (e) {
      console.error('Error in branch-tax-creditable-edit init:', e);
      this.showFormLoader = false;
    }
  }

  private setupEntityData() {
    // Use REAL data from rowData - NO TEST_ values!
    this.leId = this.rowData.LEID || '';
    this.cdr_no = this.rowData.MARS || this.rowData.CDR_NO || '';
    this.leType = this.rowData.LE_TYPE || '';

    // MANDATORY ORDER: Tax Year, LEID, LE Name
    this.entityList = [
      { key: "Tax Year", value: this.rowData.TAX_YEAR || this.filterParams.tax_year || '' },
      { key: "LEID", value: this.rowData.LEID || '' },
      { key: "LE Name", value: this.rowData.LE_NAME || '' }
    ];

    // Set modal title
    if (this.leId) {
      this.modalTitle = `Branch Tax for LEID - ${this.leId}`;
      if (this.isAmendedScenario && this.gridData?.rowData?.ISSUE_KEY) {
        this.modalTitle += ` & Issue Id- ${this.gridData.rowData.ISSUE_KEY}`;
      }
    }

    this.dataLoadingStates.entityData = true;
    this.checkAllDataLoaded();
  }

  checkAllDataLoaded() {
    const allLoaded = Object.values(this.dataLoadingStates).every(state => state);
    if (allLoaded) {
      this.showFormLoader = false;
      this.cdr.detectChanges();
    }
  }

  loadInitialData() {
    if (!this.GENERAL_CONFIG || !this.GENERAL_CONFIG.base_url) {
      return;
    }

    // Get filter params
    this.formData.filterTaxYear = this.filterParams.tax_year || this.globalService?.globalParams?.tax_year;
    this.formData.scenario = this.filterParams.scenario || this.globalService?.globalParams?.scenario;
    this.formData.clientKey = this.globalService?.globalParams?.client_key || 0;
    this.isAmendedScenario = this.globalService?.globalParams?.issue_id != 0 && this.globalService?.globalParams?.issue_id != null;

    // Get logged in user
    this.logged_in_user = this.appService.USER_SETTINGS?.sso_id || '';

    // Process gridData if available
    if (this.gridData) {
      this.processGridData();
    }

    // Load dropdowns
    this.getCodeCombinationData();
    this.getCreditableDropDown();
    this.getAttribMast();
    if (this.isAmendedScenario) {
      this.getIssueDropdown();
    }

    // Initialize tax year filters
    this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);

    // Check lock status
    this.checkLockStatus();

    // Get summary info
    this.getSummaryInfo();
  }

  processGridData() {
    // Matching AngularJS BranchTaxCtrl.js lines 329-382
    if (this.gridData && this.gridData.rowData) {
      this.gridDataMultipleSelect = _.clone(this.gridData);
      
      const rowData = this.gridDataMultipleSelect.rowData;
      
      // Get generated LEID dropdown (matching line 349)
      this.getGeneratedLeidDropDown(rowData);
      
      // Push rowData to defaultsMultipleSelected initially (matching line 350)
      // This will be cleared and repopulated when API returns
      this.defaultsMultipleSelected.push(rowData);
      
      // Set form data from rowData (matching lines 351-355)
      this.formData.branchTaxTrailBalanceAmt = this.formatNumber(rowData.TB_AMT);
      this.formData.totalBranchTaxes = this.formatNumber(rowData.SOURCED_AMT);
      this.formData.variance = this.formatNumber(rowData.VARIANCE_AMT);
      this.formData.openVariance = this.formatNumber(rowData.VARIANCE_AMT);
      this.formData.LEID = rowData.LEID;
      
      // Get tag details based on COMBINATION_KEY (matching line 357)
      // Use filterParams directly if formData values not set yet
      const taxYear = this.formData.filterTaxYear || this.filterParams?.tax_year || this.globalService?.globalParams?.tax_year;
      const scenario = this.formData.scenario || this.filterParams?.scenario || this.globalService?.globalParams?.scenario;
      
      if (this.GENERAL_CONFIG?.base_url && rowData.COMBINATION_KEY) {
        // Ensure filterTaxYear and scenario are set before calling
        this.formData.filterTaxYear = taxYear;
        this.formData.scenario = scenario;
        this.getTagDetailsData(rowData.COMBINATION_KEY);
      }
      
      // Determine panel state (matching lines 359-379)
      if (rowData.IS_DEFAULT_ALLOWED == undefined || rowData.IS_DEFAULT_ALLOWED == null) {
        if (rowData.IS_CREDITABLE == undefined || rowData.IS_CREDITABLE == null) {
          if (rowData.CREDIT_AMT == undefined || rowData.CREDIT_AMT == 0) {
            rowData["IS_CREDITABLE"] = "N";
            this.formData.panel = false;
            if (rowData.APPLICABLE_YEAR == null || rowData.APPLICABLE_YEAR == '') {
              rowData.APPLICABLE_YEAR = rowData.APPLICABLE_YEAR2;
            }
          } else {
            rowData["IS_CREDITABLE"] = "Y";
            this.formData.panel = true;
          }
        } else {
          rowData["IS_CREDITABLE"] = rowData.IS_CREDITABLE;
          this.formData.panel = (rowData.IS_CREDITABLE == 'Y');
        }
      }
      
      // Update panel states based on formData.panel
      this.formData.enableCreditablePanel = this.formData.panel;
      this.formData.enableNonCreditablePanel = !this.formData.panel;
    }
  }

  formatNumber(value: any): string {
    if (value == null || value == undefined) return '0';
    const num = parseInt(('' + value).replace(/\,/g, ''));
    return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  numberWithCommas(value: any): string {
    if (value == null || value == undefined) return '0';
    return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  checkLockStatus() {
    if (!this.GENERAL_CONFIG?.base_url || !this.filterParams?.scenario || !this.globalService?.globalParams?.jcd_key) return;

    const lockparams = {
      "action_code": 'n10cpv',
      "p_scenario": this.filterParams.scenario,
      "p_jcd_key": this.globalService.globalParams.jcd_key
    };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      lockparams,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.is_locked = response.jsonObject;
          this.formData.ReturnAsFiled = (this.is_locked != undefined && this.is_locked != null && this.is_locked[0]?.LOCK_STATUS == 'Y');
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error checking lock status:', error);
      }
    );
  }

  getCodeCombinationData() {
    if (!this.GENERAL_CONFIG?.base_url) return;

    const params = {
      "action_code": 'g1mvvs',
      "p_tax_year": this.formData.filterTaxYear,
      "p_scenario": this.formData.scenario
    };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.codeCombinationData = response.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading code combination data:', error);
      }
    );
  }

  getIssueDropdown() {
    if (!this.GENERAL_CONFIG?.base_url || !this.isAmendedScenario) return;

    const url = `${this.GENERAL_CONFIG.base_url}/getIssues?tax_year=${this.formData.filterTaxYear}&scenario=${this.formData.scenario}`;
    
    this.http.get<any>(url, { withCredentials: true }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.issueDropdownData = response.issue || [];
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading issue dropdown:', error);
      }
    );
  }

  getCreditableDropDown() {
    if (!this.GENERAL_CONFIG?.base_url) return;

    const params = { "action_code": 'e83e1x' };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.basketCatgData = _.filter(response.jsonObject, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
          this.basketCodeDefault = _.filter(this.basketCatgData, (p: any) => _.includes(['BRANCH'], p.CODE_SHORT_DESC));
          this.countryData = _.filter(response.jsonObject, (p: any) => _.includes(['COUNTRY_CODE'], p.CODE_GROUP));
          this.taxYearData = _.filter(response.jsonObject, (p: any) => _.includes(['TAX_YEAR'], p.CODE_GROUP));
          this.stdReasonCodeData = _.filter(response.jsonObject, (p: any) => _.includes(['STD_REASON_CODE'], p.CODE_GROUP));
          this.countryUS = _.filter(this.countryData, (p: any) => _.includes(['US'], p.CODE_SHORT_DESC));
          this.taxPriorYearStdReason = _.filter(this.stdReasonCodeData, (p: any) => _.includes(['TPPY'], p.CODE_SHORT_DESC));
          this.section909SplitrTax = _.filter(this.stdReasonCodeData, (p: any) => _.includes(['SUSPT'], p.CODE_SHORT_DESC));

          if (this.taxPriorYearStdReason.length > 0) {
            this.taxPriorYearCodeKey = '' + this.taxPriorYearStdReason[0].CODE_KEY;
          }
          if (this.section909SplitrTax.length > 0) {
            this.section909SplitrTaxKey = '' + this.section909SplitrTax[0].CODE_KEY;
          }

          // Set default basket
          if (this.basketCodeDefault.length > 0) {
            this.formData.selectedBasketCatg = '' + this.basketCodeDefault[0].CODE_KEY;
          }

          // Initialize tax year filters
          this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);
          this.isTaxPriorYear();

          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading creditable dropdown data:', error);
      }
    );
  }

  getAttribMast() {
    if (!this.GENERAL_CONFIG?.base_url) return;

    const params = { "action_code": 'e0vg4g' };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.attribMastData = response.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading attribute master data:', error);
      }
    );
  }

  getGeneratedLeidDropDown(selectedRowData: any) {
    if (!this.GENERAL_CONFIG?.base_url || !selectedRowData) return;

    const params = {
      "action_code": 'yxpce4',
      "scenario": this.formData.scenario,
      "ho_leid": selectedRowData.HO_LEID,
      "ho_cdr_no": selectedRowData.HO_CDR_NO,
      "ho_reporting_pd": selectedRowData.HO_REPORTING_PERIOD,
    };

    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.formData.generatedLeidDropDown = response.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading generated LEID dropdown:', error);
      }
    );
  }

  getTagDetailsData(cc_key: any) {
    // Matching AngularJS BranchTaxCtrl.js lines 153-159
    // This function ONLY makes the API call - processing happens in processTagDetailsData()
    if (!this.GENERAL_CONFIG?.base_url) {
      this.formData.spinner = false;
      return;
    }

    const issueKey = (this.gridDataMultipleSelect?.rowData?.ISSUE_KEY != undefined) 
      ? this.gridDataMultipleSelect.rowData.ISSUE_KEY : 0;
    
    // Use params matching AngularJS exactly (line 155)
    const params = {
      action_code: 'm6myyu',
      combination_key: cc_key,
      p_tax_year: this.formData.filterTaxYear,
      p_scenario: this.formData.scenario,
      p_issue_key: issueKey
    };
    
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject',
      params,
      this.globalService,
      null,
      null
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          // Set ftcTagDtlsData - this triggers processing (like $scope.$watch in AngularJS)
          this.ftcTagDtlsData = response.jsonObject;
          this.processTagDetailsData();
        } else {
          this.formData.spinner = false;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading tag details data:', error);
        this.formData.spinner = false;
        this.cdr.detectChanges();
      }
    );
  }

  processTagDetailsData() {
    // Matching AngularJS BranchTaxCtrl.js $scope.$watch on ftcTagDtlsData (lines 788-828)
    if (this.ftcTagDtlsData && this.ftcTagDtlsData.length > 0) {
      // Get all unique TAG_KEYs (matching lines 790-795)
      const allTagKeys: any[] = [];
      for (const item of this.ftcTagDtlsData) {
        if (!_.includes(allTagKeys, item.TAG_KEY)) {
          allTagKeys.push(item.TAG_KEY);
        }
      }

      // Clear defaultsMultipleSelected if we have tags (matching lines 797-799)
      if (allTagKeys.length > 0) {
        this.defaultsMultipleSelected = [];
      }

      // Process each TAG_KEY (matching lines 800-821)
      for (const tagkey of allTagKeys) {
        // Start with a copy of rowData (matching line 801: angular.copy(vm.gridDataMultipleSelect.rowData))
        const newObj: any = _.cloneDeep(this.gridDataMultipleSelect?.rowData || {});
        
        // Process all tags for this TAG_KEY (matching lines 802-815)
        for (const tag of this.ftcTagDtlsData) {
          if (tag.TAG_KEY == tagkey) {
            // Set TAG_KEY (line 804)
            newObj["TAG_KEY"] = tag.TAG_KEY;
            // Set LOCKED_STATUS_FLAG (line 805)
            newObj["LOCKED_STATUS_FLAG"] = (tag.STATUS_FLAG == 'L') ? true : false;
            // Set attribute value dynamically (line 807)
            if (tag.ATTRIB_NAME) {
              const attribName = tag.ATTRIB_NAME.replace(/(^"|"$)/g, '');
              newObj[attribName] = tag.ATTRIB_VALUE;
            }
            // Set IS_CREDITABLE (line 808)
            newObj["IS_CREDITABLE"] = tag.IS_CREDITABLE;
            // Set amount based on IS_CREDITABLE (lines 809-813)
            if (tag.IS_CREDITABLE == 'Y') {
              newObj.CREDIT_AMT = tag.BRANCH_TAXES_AMT;
            } else {
              newObj.NON_CREDIT_AMT = tag.BRANCH_TAXES_AMT;
            }
            // Set APPLICABLE_YEAR2 (line 814)
            newObj["APPLICABLE_YEAR2"] = newObj["APPLICABLE_YEAR"];
          }
          
          // Update form data values (lines 816-819) - happens for each iteration in AngularJS
          this.formData.branchTaxTrailBalanceAmt = this.formatNumber(newObj.TB_AMT);
          this.formData.openVariance = this.formatNumber(newObj.VARIANCE_AMT);
          this.formData.totalBranchTaxes = this.formatNumber(newObj.SOURCED_AMT);
          this.formData.variance = this.formatNumber(newObj.VARIANCE_AMT);
        }
        
        // Push the object to defaultsMultipleSelected (matching line 821)
        this.defaultsMultipleSelected.push(newObj);
      }
      
      // Update creditable and non-creditable records arrays
      this.updateRecordsArrays();
      
      // Set spinner to false (matching line 823)
      this.formData.spinner = false;
      
      // Trigger change detection
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    } else {
      // No data from API - set spinner to false (matching line 825)
      this.formData.spinner = false;
      this.cdr.detectChanges();
    }
  }

  updateRecordsArrays(): void {
    // Filter records matching AngularJS filters:
    // creditableTypeFilter: IS_CREDITABLE === 'Y' (line 170-174)
    // notCreditableTypeFilter: IS_CREDITABLE === 'N' (line 177-180)
    this.creditableRecords = this.defaultsMultipleSelected.filter((t: any) => t.IS_CREDITABLE === 'Y');
    this.nonCreditableRecords = this.defaultsMultipleSelected.filter((t: any) => t.IS_CREDITABLE === 'N');
  }

  getSummaryInfo() {
    if (!this.GENERAL_CONFIG?.base_url || !this.rowData) return;

    const params = {
      sso_id: this.logged_in_user,
      scenario: this.formData.scenario,
      leid: this.rowData.LEID,
      cdr_no: this.rowData.CDR_NO,
      reporting_period: this.rowData.REPORTING_PERIOD,
      me_code: this.rowData.ME_CODE
    };

    this.branchTaxService.getSummaryInfo(
      this.GENERAL_CONFIG.base_url,
      params,
      this.globalService
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.callSuccess == '1' && response.jsonObject) {
          this.summaryInfo = response.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading summary info:', error);
      }
    );
  }

  getCountryDesc(countryKey: string): string {
    const country = this.countryData.find((c: any) => '' + c.CODE_KEY === countryKey);
    return country ? country.CODE_DISP_DESC : '';
  }

  getBasketDesc(basketKey: string): string {
    const basket = this.basketCatgData.find((b: any) => '' + b.CODE_KEY === basketKey);
    return basket ? basket.CODE_DISP_DESC : '';
  }

  getTaxYearDesc(taxYearKey: string): string {
    const taxYear = this.taxYearData.find((t: any) => '' + t.CODE_KEY === taxYearKey);
    return taxYear ? taxYear.CODE_DISP_DESC : '';
  }

  getStdReasonDesc(reasonKey: string): string {
    const reason = this.stdReasonCodeData.find((r: any) => '' + r.CODE_KEY === reasonKey);
    return reason ? reason.CODE_DISP_DESC : '';
  }

  tillCurrentTaxYear(currentYr: number, fromPriorYr: number, tillPriorYr: number) {
    this.filteredTaxYearData = [];
    this.filteredTaxYearForCreditable = [];

    for (const taxYear of this.taxYearData) {
      if (taxYear.CODE_GROUP === 'TAX_YEAR' &&
        taxYear.CODE_DISP_DESC <= (currentYr - fromPriorYr) &&
        taxYear.CODE_DISP_DESC >= (currentYr - tillPriorYr)) {
        this.filteredTaxYearData.push(taxYear);
        this.filteredTaxYearForCreditable.push(taxYear);
      }
    }

    // Defaulting the NonCreditable Applicable Year to Default Current Year
    this.formData.applicableYearKey2 = this.getTaxYearKey(currentYr - fromPriorYr);
    // Defaulting the Creditable Applicable Year to Default Current Year
    this.formData.applicableYearKey = this.getTaxYearKey(currentYr - fromPriorYr);

    this.cdr.detectChanges();
  }

  isTaxPriorYear() {
    if (this.formData.selectStdReasonCd && this.formData.selectStdReasonCd == this.taxPriorYearCodeKey) {
      this.tillCurrentTaxYear(this.formData.filterTaxYear, 1, 11);
    } else {
      this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);
    }

    this.formData.isSection909SplitrTax = (this.formData.selectStdReasonCd && this.formData.selectStdReasonCd == this.section909SplitrTaxKey);
    if (this.formData.isSection909SplitrTax) {
      this.formData.selectedSplitterBasketCatg = '' + this.basketCodeDefault[0]?.CODE_KEY;
    }
    this.cdr.detectChanges();
  }

  getCountryKey(countryDesc: string): string {
    const country = this.countryData.find((c: any) => c.CODE_DISP_DESC === countryDesc);
    return country ? '' + country.CODE_KEY : '';
  }

  getTaxYearKey(taxYearDesc: number): string {
    const taxYear = this.taxYearData.find((t: any) => t.CODE_DISP_DESC == taxYearDesc);
    return taxYear ? '' + taxYear.CODE_KEY : '';
  }

  changeLeCountry() {
    const selectedLeid = this.formData.generatedLeidDropDown.find((l: any) => l.LEID_LABEL === this.formData.genLeid);
    if (selectedLeid) {
      const country = this.countryData.find((c: any) => c.CODE_SHORT_DESC === selectedLeid.COUNTRY_CODE);
      if (country) {
        this.formData.selectedCountryDesc = country.CODE_DISP_DESC;
        this.formData.selectedCountryKey = '' + country.CODE_KEY;
        this.formData.selectedBranchTaxLEID_Orgnl_CountryKey = '' + country.CODE_KEY;
      }
    }
    this.updateExplainUsEntity();
    this.cdr.detectChanges();
  }

  updateExplainUsEntity() {
    if (this.formData.explainUsEntityRestore == '' && (this.formData.explainUsEntity != 'Not Applicable' && this.formData.explainUsEntity != '')) {
      this.formData.explainUsEntityRestore = this.formData.explainUsEntity;
    }
    if (this.formData.selectedBranchTaxLEID_Orgnl_CountryKey == this.countryUS[0]?.CODE_KEY) {
      if (this.formData.explainUsEntity == 'Not Applicable' && this.formData.explainUsEntityRestore == '') {
        this.formData.explainUsEntity = '';
      } else {
        this.formData.explainUsEntity = this.formData.explainUsEntityRestore;
      }
    } else {
      this.formData.explainUsEntity = 'Not Applicable';
    }
  }

  onRadioChange() {
    this.formData.enableCreditablePanel = this.formData.panel;
    this.formData.enableNonCreditablePanel = !this.formData.panel;
    this.cdr.detectChanges();
  }

  editCreditableTaxRow(selectedRowData: any) {
    // Populate form with selected row data
    const basket = this.basketCatgData.find((b: any) => b.CODE_DISP_DESC == selectedRowData.BASKET);
    if (basket) {
      this.formData.selectedBasketCatg = '' + basket.CODE_KEY;
    }

    const taxYear = this.taxYearData.find((t: any) => t.CODE_DISP_DESC == selectedRowData.APPLICABLE_YEAR);
    if (taxYear) {
      this.formData.applicableYearKey = '' + taxYear.CODE_KEY;
    }

    this.formData.genLeid = selectedRowData.GEN_LEID.toUpperCase();
    this.formData.selectedCountryDesc = selectedRowData.COUNTRY;
    this.formData.selectedCountryKey = '' + this.getCountryKey(selectedRowData.COUNTRY);
    this.formData.selectedSavedCountryKey = '' + this.getCountryKey(selectedRowData.COUNTRY);
    this.formData.editFlagSet = true;
    this.formData.creditableTagKey = selectedRowData.TAG_KEY;
    this.formData.explainUsEntity = (selectedRowData.EXPLANATION_CREDITABLE_US_ENTITY != null && selectedRowData.EXPLANATION_CREDITABLE_US_ENTITY != '') 
      ? selectedRowData.EXPLANATION_CREDITABLE_US_ENTITY : 'Not Applicable';
    this.formData.explainUsEntityRestore = '';
    this.formData.creditTaxAmt = parseInt('' + selectedRowData.CREDIT_AMT);
    this.formData.branchTaxTrailBalanceAmt = this.formatNumber(selectedRowData.TB_AMT);
    this.formData.variance = this.formatNumber(selectedRowData.VARIANCE_AMT);
    this.formData.totalBranchTaxes = this.formatNumber(selectedRowData.SOURCED_AMT);

    // Update country based on LEID
    for (const row of this.formData.generatedLeidDropDown) {
      if (row.LEID_LABEL == this.formData.genLeid) {
        for (const country of this.countryData) {
          if (country.CODE_SHORT_DESC == row.COUNTRY_CODE) {
            this.formData.selectedBranchTaxLEID_Orgnl_CountryKey = '' + country.CODE_KEY;
            this.formData.selectedBranchTaxLEID_Orgnl_CountryDesc = country.CODE_DISP_DESC;
          }
        }
      }
    }

    if (this.formData.explainUsEntityRestore == '' && (this.formData.explainUsEntity != 'Not Applicable' && this.formData.explainUsEntity != '')) {
      this.formData.explainUsEntityRestore = this.formData.explainUsEntity;
    }
    if (this.formData.selectedBranchTaxLEID_Orgnl_CountryKey == this.countryUS[0]?.CODE_KEY) {
      if (this.formData.explainUsEntity == 'Not Applicable' && this.formData.explainUsEntityRestore == '') {
        this.formData.explainUsEntity = '';
      } else {
        this.formData.explainUsEntity = this.formData.explainUsEntityRestore;
      }
    } else {
      this.formData.explainUsEntity = 'Not Applicable';
    }

    this.formData.panel = true;
    this.formData.enableCreditablePanel = true;
    this.formData.enableNonCreditablePanel = false;
    this.cdr.detectChanges();
  }

  editNonCreditableTaxRow(selectedRowData: any) {
    // Matching AngularJS BranchTaxCtrl.js lines 669-708
    
    // Set Standard Reason Code (lines 672-681)
    const reason = this.stdReasonCodeData.find((r: any) => r.CODE_DISP_DESC == selectedRowData.STANDARD_REASON_NOT_CREDITABLE);
    if (reason) {
      this.formData.selectStdReasonCd = '' + reason.CODE_KEY;
      // Set isSection909SplitrTax based on selected reason (lines 675-679)
      this.formData.isSection909SplitrTax = (this.formData.selectStdReasonCd == this.section909SplitrTaxKey);
    }
    
    // Call isTaxPriorYear to reset Applicable Year dropdown (line 682)
    this.isTaxPriorYear();
    
    // Set Applicable Year - use APPLICABLE_YEAR2 or APPLICABLE_YEAR (lines 684-688)
    const taxYear = this.taxYearData.find((t: any) => 
      t.CODE_DISP_DESC == selectedRowData.APPLICABLE_YEAR2 || t.CODE_DISP_DESC == selectedRowData.APPLICABLE_YEAR
    );
    if (taxYear) {
      this.formData.applicableYearKey2 = '' + taxYear.CODE_KEY;
    }
    
    // Set Country for Section 909 Splitter Tax (lines 690-695)
    const country = this.countryData.find((c: any) => c.CODE_DISP_DESC == selectedRowData.COUNTRY);
    if (country) {
      this.formData.selectedSplitterCountryKey = '' + country.CODE_KEY;
      this.formData.selectedSplitterCountryDesc = country.CODE_DISP_DESC;
    }
    
    // Set Basket for Section 909 Splitter Tax (lines 696-700)
    const basket = this.basketCatgData.find((b: any) => b.CODE_DISP_DESC == selectedRowData.BASKET);
    if (basket) {
      this.formData.selectedSplitterBasketCatg = '' + basket.CODE_KEY;
    }
    
    // Set other form fields (lines 702-707)
    this.formData.editFlagSet = true;
    this.formData.nonCrdtableTagKey = selectedRowData.TAG_KEY;
    this.formData.nonCrdBrAmount = parseInt('' + selectedRowData.NON_CREDIT_AMT);
    this.formData.openVariance = this.formatNumber(selectedRowData.VARIANCE_AMT);
    this.formData.detailReason = selectedRowData.DETAIL_REASON_NOT_CREDITABLE;

    this.formData.panel = false;
    this.formData.enableCreditablePanel = false;
    this.formData.enableNonCreditablePanel = true;
    this.cdr.detectChanges();
  }

  deleteRow(selectedRowData: any) {
    if (!confirm('Are you sure to remove this Tax Amount?')) {
      return;
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      scenario: this.formData.scenario,
      object_id: selectedRowData.COMBINATION_KEY,
      tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      jcd_key: this.globalService?.globalParams?.jcd_key || this.filterParams.jcd_key || 250,
      screen_key: this.globalService?.globalParams?.screen_key || this.filterParams.screen_key
    };

    const returnObj: any = {
      TAG_KEY: selectedRowData.TAG_KEY,
      COMBINATION_KEY: selectedRowData.COMBINATION_KEY,
      OPERATION_TYPE: 'D',
      GROUP_ID: 1,
      IS_CREDITABLE: 'D',
      "0_0": '0',
      AMOUNT: 0
    };

    const defaultsChangeDetails = [returnObj];

    this.branchTaxService.saveBranchTaxCreditableForm(
      this.GENERAL_CONFIG.base_url,
      returnClobSettingsObj,
      defaultsChangeDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar("Branch Tax Data has been successfully Deleted", 'gtw-snackbar--green', true, 4);
          // Remove from defaultsMultipleSelected
          this.defaultsMultipleSelected = this.defaultsMultipleSelected.filter((t: any) => t.TAG_KEY != selectedRowData.TAG_KEY);
          this.updateRecordsArrays();
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        console.error('Error deleting branch tax:', error);
        const errorMessage = error?.error?.errorMessage || error?.errorMessage ||
          (error?.error?.data?.errorMessage) ||
          "Error deleting branch tax. Please try again.";

        this.gtwSnackbar.openSnackBar(errorMessage, 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  saveCreditAmtBranchTaxForm(): void {
    if (this.isSaveClicked) return;

    if (this.formData.ReturnAsFiled) {
      this.gtwSnackbar.openSnackBar(`Tax Return has already been filed for tax year ${this.formData.filterTaxYear}.`, 'gtw-snackbar--red', true, 4);
      return;
    }

    // Validation
    if (!this.formData.selectedBasketCatg || !this.formData.selectedCountryDesc || !this.formData.genLeid || !this.formData.applicableYearKey) {
      this.gtwSnackbar.openSnackBar("Please select/enter all the fields.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.selectedBranchTaxLEID_Orgnl_CountryKey == this.countryUS[0]?.CODE_KEY && 
        (!this.formData.explainUsEntity || this.formData.explainUsEntity == '')) {
      this.gtwSnackbar.openSnackBar("Please enter explanation why Branch Tax LEID is US entity", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (!this.formData.creditTaxAmt || this.formData.creditTaxAmt == '') {
      this.gtwSnackbar.openSnackBar("Please enter a valid Branch Tax Creditable Amount.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.creditTaxAmt != undefined && this.formData.creditTaxAmt != null) {
      const validNumberWithDecimals = ((parseInt('' + this.formData.creditTaxAmt) - parseFloat('' + this.formData.creditTaxAmt)) !== 0);
      if (validNumberWithDecimals) {
        this.gtwSnackbar.openSnackBar("Please do not enter decimals for Branch Tax Creditable Amount.", 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const key = 0;
    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      scenario: this.formData.scenario,
      object_id: this.defaultsMultipleSelected[key] ? this.defaultsMultipleSelected[key].COMBINATION_KEY : this.rowData.COMBINATION_KEY,
      tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      jcd_key: this.globalService?.globalParams?.jcd_key || this.filterParams.jcd_key || 250,
      screen_key: this.globalService?.globalParams?.screen_key || this.filterParams.screen_key
    };

    const returnObj: any = {
      ISSUE_KEY: (this.gridDataMultipleSelect && this.gridDataMultipleSelect.rowData && this.gridDataMultipleSelect.rowData.ISSUE_KEY != undefined)
        ? this.gridDataMultipleSelect.rowData.ISSUE_KEY : this.formData.selectedIssue,
      COMBINATION_KEY: this.defaultsMultipleSelected[key] ? this.defaultsMultipleSelected[key].COMBINATION_KEY : this.rowData.COMBINATION_KEY
    };

    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET'])?.ATTRIB_KEY + '_0'] = this.formData.selectedBasketCatg;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'GEN_LEID'])?.ATTRIB_KEY + '_0'] = this.formData.genLeid;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY'])?.ATTRIB_KEY + '_0'] = this.getCountryKey(this.formData.selectedCountryDesc);
    // Only include EXPLANATION_CREDITABLE_US_ENTITY if it's not "Not Applicable" (when country is not US, send empty string)
    const explanationValue = (this.formData.explainUsEntity === 'Not Applicable') ? '' : this.formData.explainUsEntity.replace(/'/g, "'");
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'EXPLANATION_CREDITABLE_US_ENTITY'])?.ATTRIB_KEY + '_0'] = explanationValue;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'APPLICABLE_YEAR'])?.ATTRIB_KEY + '_0'] = this.formData.applicableYearKey;
    returnObj["IS_CREDITABLE"] = 'Y';
    returnObj["AMOUNT"] = ((this.formData.creditTaxAmt != undefined || this.formData.creditTaxAmt != null) 
      ? this.formData.creditTaxAmt : this.defaultsMultipleSelected[key]?.CREDIT_AMT || 0);
    returnObj['GROUP_ID'] = 1;

    if (this.formData.editFlagSet) {
      if (this.formData.creditableTagKey != undefined && this.formData.creditableTagKey != null) {
        returnObj["TAG_KEY"] = this.formData.creditableTagKey;
        returnObj["OPERATION_TYPE"] = 'U';
      } else {
        returnObj["TAG_KEY"] = null;
        returnObj["OPERATION_TYPE"] = 'I';
      }
    } else {
      returnObj["TAG_KEY"] = null;
      returnObj["OPERATION_TYPE"] = 'I';
    }

    const defaultsChangeDetails = [returnObj];

    this.branchTaxService.saveBranchTaxCreditableForm(
      this.GENERAL_CONFIG.base_url,
      returnClobSettingsObj,
      defaultsChangeDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar("Creditable Tax has been successfully saved/updated", 'gtw-snackbar--green', true, 4);
          
          // Add/update the saved record in defaultsMultipleSelected to display in the table
          this.addOrUpdateCreditableRecord(returnObj);
          
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        console.error('Error saving creditable branch tax:', error);
        const errorMessage = error?.error?.errorMessage || error?.errorMessage ||
          (error?.error?.data?.errorMessage) ||
          "Error saving creditable branch tax. Please try again.";

        this.gtwSnackbar.openSnackBar(errorMessage, 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  saveNonCreditAmtBranchTaxForm(): void {
    if (this.isSaveClicked) return;

    if (this.formData.ReturnAsFiled) {
      this.gtwSnackbar.openSnackBar(`Tax Return has already been filed for tax year ${this.formData.filterTaxYear}.`, 'gtw-snackbar--red', true, 4);
      return;
    }

    // Validation
    if (!this.formData.selectStdReasonCd || !this.formData.detailReason || !this.formData.applicableYearKey2) {
      this.gtwSnackbar.openSnackBar("Please select/enter all the fields.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (!this.formData.nonCrdBrAmount || this.formData.nonCrdBrAmount == '') {
      this.gtwSnackbar.openSnackBar("Please enter a valid Branch Tax Non-Creditable Amount.", 'gtw-snackbar--red', true, 4);
      return;
    }

    if (this.formData.nonCrdBrAmount != undefined && this.formData.nonCrdBrAmount != null) {
      const validNumberWithDecimals = ((parseInt('' + this.formData.nonCrdBrAmount) - parseFloat('' + this.formData.nonCrdBrAmount)) !== 0);
      if (validNumberWithDecimals) {
        this.gtwSnackbar.openSnackBar("Please do not enter decimals for Branch Tax Non-Creditable Amount.", 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    if (this.formData.selectStdReasonCd != undefined && this.formData.selectStdReasonCd == this.section909SplitrTaxKey) {
      if (!this.formData.selectedSplitterBasketCatg || !this.formData.selectedSplitterCountryDesc) {
        this.gtwSnackbar.openSnackBar("Please select Basket and Country for selected Standard Reason Amount is Non-Creditable.", 'gtw-snackbar--red', true, 4);
        return;
      }
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const key = 0;
    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      scenario: this.formData.scenario,
      object_id: this.defaultsMultipleSelected[key] ? this.defaultsMultipleSelected[key].COMBINATION_KEY : this.rowData.COMBINATION_KEY,
      tax_year: this.formData.filterTaxYear || this.filterParams.tax_year || this.globalService?.globalParams?.tax_year,
      jcd_key: this.globalService?.globalParams?.jcd_key || this.filterParams.jcd_key || 250,
      screen_key: this.globalService?.globalParams?.screen_key || this.filterParams.screen_key
    };

    const returnObj: any = {
      ISSUE_KEY: (this.gridDataMultipleSelect && this.gridDataMultipleSelect.rowData && this.gridDataMultipleSelect.rowData.ISSUE_KEY != undefined)
        ? this.gridDataMultipleSelect.rowData.ISSUE_KEY : this.formData.selectedIssue,
      COMBINATION_KEY: this.defaultsMultipleSelected[key] ? this.defaultsMultipleSelected[key].COMBINATION_KEY : this.rowData.COMBINATION_KEY
    };

    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'STANDARD_REASON_NOT_CREDITABLE'])?.ATTRIB_KEY + '_0'] = this.formData.selectStdReasonCd;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'APPLICABLE_YEAR'])?.ATTRIB_KEY + '_0'] = this.formData.applicableYearKey2;
    returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'DETAIL_REASON_NOT_CREDITABLE'])?.ATTRIB_KEY + '_0'] =
      this.formData.detailReason.replace(/'/g, "'");

    if (this.formData.isSection909SplitrTax) {
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET'])?.ATTRIB_KEY + '_0'] = this.formData.selectedSplitterBasketCatg;
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY'])?.ATTRIB_KEY + '_0'] = this.getCountryKey(this.formData.selectedSplitterCountryDesc);
    } else {
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'BASKET'])?.ATTRIB_KEY + '_0'] = 0;
      returnObj[_.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY'])?.ATTRIB_KEY + '_0'] = 0;
    }

    returnObj["IS_CREDITABLE"] = 'N';
    returnObj["AMOUNT"] = ((this.formData.nonCrdBrAmount != null) 
      ? this.formData.nonCrdBrAmount : this.defaultsMultipleSelected[key]?.NON_CREDIT_AMT || 0);
    returnObj['GROUP_ID'] = 1;

    if (this.formData.editFlagSet) {
      if (this.formData.nonCrdtableTagKey != undefined && this.formData.nonCrdtableTagKey != null) {
        returnObj["TAG_KEY"] = this.formData.nonCrdtableTagKey;
        returnObj["OPERATION_TYPE"] = 'U';
      } else {
        returnObj["TAG_KEY"] = null;
        returnObj["OPERATION_TYPE"] = 'I';
      }
    } else {
      returnObj["TAG_KEY"] = null;
      returnObj["OPERATION_TYPE"] = 'I';
    }

    const defaultsChangeDetails = [returnObj];

    this.branchTaxService.saveBranchTaxCreditableForm(
      this.GENERAL_CONFIG.base_url,
      returnClobSettingsObj,
      defaultsChangeDetails,
      this.globalService,
      this.filterParams,
      this.rowData
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar("Non-Creditable Tax has been successfully saved/updated", 'gtw-snackbar--green', true, 4);
          
          // Add/update the saved record in defaultsMultipleSelected to display in the table
          this.addOrUpdateNonCreditableRecord(returnObj);
          
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        console.error('Error saving non-creditable branch tax:', error);
        const errorMessage = error?.error?.errorMessage || error?.errorMessage ||
          (error?.error?.data?.errorMessage) ||
          "Error saving non-creditable branch tax. Please try again.";

        this.gtwSnackbar.openSnackBar(errorMessage, 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  resetCreditable(): void {
    this.formData.selectedBasketCatg = '' + this.basketCodeDefault[0]?.CODE_KEY;
    this.formData.creditTaxAmt = '';
    this.formData.genLeid = '';
    this.formData.selectedCountryDesc = '';
    this.formData.selectedCountryKey = '';
    this.formData.selectedBranchTaxLEID_Orgnl_CountryKey = '';
    this.formData.applicableYearKey = this.getTaxYearKey(this.formData.filterTaxYear);
    this.formData.explainUsEntity = 'Not Applicable';
    this.formData.creditableTagKey = null;
    this.formData.editFlagSet = false;
    this.cdr.detectChanges();
  }

  resetNonCreditable(): void {
    this.tillCurrentTaxYear(this.formData.filterTaxYear, 0, 11);
    this.formData.selectStdReasonCd = '';
    this.formData.detailReason = '';
    this.formData.applicableYearKey2 = this.getTaxYearKey(this.formData.filterTaxYear);
    this.formData.nonCrdBrAmount = '';
    this.formData.selectedSplitterBasketCatg = '' + this.basketCodeDefault[0]?.CODE_KEY;
    this.formData.selectedSplitterCountryDesc = '';
    this.formData.nonCrdtableTagKey = null;
    this.formData.editFlagSet = false;
    this.cdr.detectChanges();
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  addOrUpdateCreditableRecord(returnObj: any): void {
    // Build the record object from form data (matching processTagDetailsData structure)
    const record: any = {
      TAG_KEY: returnObj.TAG_KEY || this.formData.creditableTagKey,
      COMBINATION_KEY: returnObj.COMBINATION_KEY,
      IS_CREDITABLE: 'Y',
      CREDIT_AMT: this.formData.creditTaxAmt || 0,
      NON_CREDIT_AMT: 0,
      GEN_LEID: this.formData.genLeid || '',
      COUNTRY: this.formData.selectedCountryDesc || '',
      BASKET: this.getBasketDesc(this.formData.selectedBasketCatg),
      APPLICABLE_YEAR: this.getTaxYearDesc(this.formData.applicableYearKey),
      APPLICABLE_YEAR2: this.getTaxYearDesc(this.formData.applicableYearKey),
      EXPLANATION_CREDITABLE_US_ENTITY: (this.formData.explainUsEntity === 'Not Applicable') ? '' : this.formData.explainUsEntity,
      STANDARD_REASON_NOT_CREDITABLE: '',
      DETAIL_REASON_NOT_CREDITABLE: ''
    };

    // If updating existing record, find and update it; otherwise add new
    if (this.formData.editFlagSet && this.formData.creditableTagKey) {
      const index = this.defaultsMultipleSelected.findIndex((t: any) => t.TAG_KEY === this.formData.creditableTagKey);
      if (index !== -1) {
        // Create new array reference to trigger change detection
        this.defaultsMultipleSelected = [
          ...this.defaultsMultipleSelected.slice(0, index),
          record,
          ...this.defaultsMultipleSelected.slice(index + 1)
        ];
      } else {
        // New record - add it with new array reference
        this.defaultsMultipleSelected = [...this.defaultsMultipleSelected, record];
      }
    } else {
      // New record - add it with new array reference
      this.defaultsMultipleSelected = [...this.defaultsMultipleSelected, record];
    }
    this.updateRecordsArrays();
    this.cdr.detectChanges();
  }

  addOrUpdateNonCreditableRecord(returnObj: any): void {
    // Build the record object from form data (matching processTagDetailsData structure)
    const record: any = {
      TAG_KEY: returnObj.TAG_KEY || this.formData.nonCrdtableTagKey,
      COMBINATION_KEY: returnObj.COMBINATION_KEY,
      IS_CREDITABLE: 'N',
      CREDIT_AMT: 0,
      NON_CREDIT_AMT: this.formData.nonCrdBrAmount || 0,
      GEN_LEID: '',
      COUNTRY: this.formData.isSection909SplitrTax ? this.formData.selectedSplitterCountryDesc : '',
      BASKET: this.formData.isSection909SplitrTax ? this.getBasketDesc(this.formData.selectedSplitterBasketCatg) : '',
      APPLICABLE_YEAR: this.getTaxYearDesc(this.formData.applicableYearKey2),
      APPLICABLE_YEAR2: this.getTaxYearDesc(this.formData.applicableYearKey2),
      EXPLANATION_CREDITABLE_US_ENTITY: '',
      STANDARD_REASON_NOT_CREDITABLE: this.getStdReasonDesc(this.formData.selectStdReasonCd),
      DETAIL_REASON_NOT_CREDITABLE: this.formData.detailReason || ''
    };

    // If updating existing record, find and update it; otherwise add new
    if (this.formData.editFlagSet && this.formData.nonCrdtableTagKey) {
      const index = this.defaultsMultipleSelected.findIndex((t: any) => t.TAG_KEY === this.formData.nonCrdtableTagKey);
      if (index !== -1) {
        // Create new array reference to trigger change detection
        this.defaultsMultipleSelected = [
          ...this.defaultsMultipleSelected.slice(0, index),
          record,
          ...this.defaultsMultipleSelected.slice(index + 1)
        ];
      } else {
        // New record - add it with new array reference
        this.defaultsMultipleSelected = [...this.defaultsMultipleSelected, record];
      }
    } else {
      // New record - add it with new array reference
      this.defaultsMultipleSelected = [...this.defaultsMultipleSelected, record];
    }
    this.updateRecordsArrays();
    this.cdr.detectChanges();
  }

  getCreditableRecords(): any[] {
    return this.creditableRecords;
  }

  getNonCreditableRecords(): any[] {
    return this.nonCreditableRecords;
  }
}

